// Lovingly ripped off from https://github.com/studio24/cookie-message/blob/master/cookie-message.js
const CookieWarning  = {
  init() {
    let cookieElement = $('#cookie-message');

    if (cookieElement.length == 0) {
      return;
    }

    let cookie = this.readCookie('seen-cookie-message');

    if (cookie != null && cookie == 'yes') {
      cookieElement.hide();
    } else {
      cookieElement.show();
    }

    this.createCookie('seen-cookie-message','yes');
  },

  createCookie(name,value) {
    let date = new Date();
    date.setTime(date.getTime()+(365*24*60*60*1000));
    let expires = "; expires="+date.toGMTString();

    document.cookie = name+"="+value+expires+"; path=/; domain=thinksmart.careers";
  },

  readCookie(name) {
    let nameEQ = name + "=";
    let ca = document.cookie.split(';');
    for(let i=0;i < ca.length;i++) {
      let c = ca[i];
      while (c.charAt(0)==' ') c = c.substring(1,c.length);
      if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length,c.length);
    }
    return null;
  }
}

$(document).ready(()=> {
  CookieWarning.init();
});
